import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const LeaveTypeUrl = `${Base_Url}/LeaveType`;

export const GetLeaveTypeList = async (params) => {
  const res = await postApiWithAuthorization(
    `${LeaveTypeUrl}/GetLeaveTypeList`,
    params
  );
  return res;
};

export const AddUpdateLeaveType = async (params) => {
  const res = await postApiWithAuthorization(
    `${LeaveTypeUrl}/AddUpdateLeaveType?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetLeaveTypeModel = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${LeaveTypeUrl}/GetLeaveTypeModel?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&LeaveTypeKeyID=${KeyID}`
  );
  return res;
};

export const ChangeLeaveTypeStatus = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${LeaveTypeUrl}/ChangeLeaveTypeStatus?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&LeaveTypeKeyID=${KeyID}`
  );
  return res;
};

export const DeleteLeaveType = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${LeaveTypeUrl}/DeleteLeaveType?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&LeaveTypeKeyID=${KeyID}`
  );
  return res;
};
